module.exports = __webpack_public_path__ + "assets/img/1SHOT.189b255a.png";